export const id = <A>(a: A): A => a;

export abstract class Either<L, R> {
  abstract fold<B>(ifLeft: (l: L) => B, ifRight: (r: R) => B): B;

  public getOrElse = (dflt: () => R): R => this.fold((_) => dflt(), id);

  public isLeft(): boolean {
    return this.fold(
      (_) => true,
      (_) => false
    );
  }

  public isRight(): boolean {
    return this.fold(
      (_) => false,
      (_) => true
    );
  }

  public toString(): string {
    return this.fold(
      (l) => `Left(${l})`,
      (r) => `Right(${r})`
    );
  }
}

class Left<L, R> extends Either<L, R> {
  constructor(private readonly l: L) {
    super();
  }

  public get value(): L {
    return this.l;
  }

  public fold<B>(ifLeft: (l: L) => B, ifRight: (r: R) => B): B {
    return ifLeft(this.l);
  }
}

class Right<L, R> extends Either<L, R> {
  constructor(private readonly r: R) {
    super();
  }

  public get value(): R {
    return this.r;
  }

  public fold<B>(ifLeft: (l: L) => B, ifRight: (r: R) => B): B {
    return ifRight(this.r);
  }
}

export const left = <L, R>(l: L): Either<L, R> => new Left<L, R>(l);
export const right = <L, R>(r: R): Either<L, R> => new Right<L, R>(r);
